import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Copy, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { ReportWithWorksheet } from "@/components/ReportWithWorksheet";
import { api, errMsg } from "@/lib/api";
import { CoachNotes } from "@/components/CoachNotes";

export default function IndividualReport() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/submissions/${id}`).then((r) => setData(r.data)).catch((e) => setError(errMsg(e)));
  }, [id]);

  if (error) return <p data-testid="report-error" className="text-red-600">{error}</p>;
  if (!data) return <Loader2 className="mx-auto h-6 w-6 animate-spin text-[#1F4266]" />;

  const link = `${window.location.origin}/report/${data.report_token}`;
  return (
    <div className="space-y-6">
      <div className="no-print flex flex-wrap items-center justify-between gap-3">
        <Link to="/entries" data-testid="back-to-entries" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-[#1F4266]">
          <ArrowLeft className="h-4 w-4" /> Back to entries
        </Link>
        <div className="flex flex-wrap gap-2">
        <Link to={`/reports/person/${encodeURIComponent(data.person_key || data.id)}`} data-testid="view-all-results-link" className="inline-flex items-center rounded-full border border-slate-200 bg-white px-3 py-1.5 text-sm font-medium text-[#1F4266] hover:bg-slate-50">
          All results &amp; progress
        </Link>
        <Button
          data-testid="copy-participant-link"
          variant="outline"
          size="sm"
          className="rounded-full"
          onClick={() => navigator.clipboard.writeText(link).then(() => toast.success("Participant link copied"))}
        >
          <Copy className="mr-2 h-3.5 w-3.5" /> Copy participant link
        </Button>
        </div>
      </div>
      <CoachNotes submissionId={data.id} />
      <ReportWithWorksheet data={data} />
    </div>
  );
}
